import { RealEventsMap } from '@/modules/Metrix/types';
import { deepSerializationCopy } from '@/app/tools/objectUtils';
import { ProtocolType, EventsMap } from '@/app/modules/Metrics/types';
import { Cloneable } from '@/app/tools/Cloneable';

/**
 * Контейнер, спавнящий прототипы заданных в `events.ts` событий и/или создающий deep-копии объектов
 */
export default class EventsPrototypesHolder {
    protected readonly eventsMap: RealEventsMap = {};

    /**
     * Мержит события в свое хранилище
     *
     * @param newEvents
     */
    public addEvents(newEvents: EventsMap<ProtocolType>) {
        Object.assign(this.eventsMap, newEvents);
    }

    /**
     * @param event
     */
    public hasEvent(event: string | number) {
        return this.eventsMap.hasOwnProperty(event);
    }

    /**
     * Делаем вложенную копию события
     *
     * @param event
     */
    public getCopy(event: string | number) {
        const eventData = this.eventsMap[event];

        return Object.keys(eventData).reduce((acc, key) => {
            const value = eventData[key];

            if (typeof value === 'object') {
                if (value instanceof Cloneable) {
                    acc[key] = value.clone();
                } else {
                    acc[key] = deepSerializationCopy(value);
                }
            } else {
                acc[key] = value;
            }

            return acc;
        }, {} as { [key: string]: any });
    }
}
